import { createSlice } from '@reduxjs/toolkit';

import { checkUserIsConnectedOnStart } from '@/domain/auth/actions/check-user-connected-on-start.action';
import { getUserInfos } from '@/domain/auth/actions/get-user-infos.action';
import { signInStep2UseReceivedCodeToLogin } from '@/domain/auth/actions/sign-in-step2-use-received-code-to-login.action';
import { signOutUser } from '@/domain/auth/actions/sign-out-user.action';
import { User } from '@/domain/auth/entities/user.entity';

export type AuthState = {
  isAuthenticated: boolean;
  userInfos: User;
};

const initialState: AuthState = {
  isAuthenticated: false,
  userInfos: {
    id: '',
    email: '',
    username: '',
    firstname: '',
    lastname: '',
    licenses: [],
    trial: {
      isOnTrial: false,
    },
  },
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(signInStep2UseReceivedCodeToLogin.fulfilled, (state, action) => {
        state.isAuthenticated = action.payload.authorized;
      })
      .addCase(signOutUser.fulfilled, (state) => {
        state.userInfos = initialState.userInfos;
        state.isAuthenticated = false;
      })
      .addCase(checkUserIsConnectedOnStart.fulfilled, (state, action) => {
        state.isAuthenticated = action.payload.connected;
      })
      .addCase(getUserInfos.fulfilled, (state, action) => {
        state.userInfos = action.payload;
      });
  },
});
